import Component from "@tunnel-components/@sharded/@widgets/virtualized/pagination/component";
import * as React from "react";
import { connect } from "react-redux";
import * as Lodash from "lodash";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @method componentDidUpdate
 * @method componentWillReceiveProps
 * @method render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @property { object }       state
     * @property { boolean }      state.errorserver
     * @property { boolean }      state.loading
     * ......
     */
    this.state = {
      activePage: [],
      currentPageNumbers: props.currentPageNumbers,
      firstCurrentPageLimit: 10, // la taille limite de la pagination visible
      itemPerPage: props.itemPerPage,
      itemPerRow: props.itemPerRow,
      loading: false,
      pageNumbers: [], // le
      scrollTop: 0,
      stableValue: 3, // la valeur d'écart
      totalItemLength: props.totalItemLength,
      totalRowElements: props.totalRowElements,
      visible: [], // Le Tableau des numéros visibles
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.handleScroll = this.handleScroll.bind(this);
    this.onNextPage = this.onNextPage.bind(this); // Aller à la page suivante
    this.onSelectedPage = this.onSelectedPage.bind(this); // Aller à la page sélectionnée
    this.onPreviousPage = this.onPreviousPage.bind(this); // Revenir à la page précedente
    this.onLastPage = this.onLastPage.bind(this); // Aller à la dernière page
    this.onFirstPage = this.onFirstPage.bind(this); // Aller à la prémière page
  }
  /**
   * @method onNextPage
   * @description: navigation de la pagination ( Aller à la page suivante )
   * @param { any }    event
   * @infos "https://reactjs.org"
   */
  public onNextPage = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** comparaison de la viariable  */
    }

    if (1 <= this.state.currentPageNumbers) {
      if (
        this.state.currentPageNumbers <
        Math.ceil(this.state.totalItemLength / this.state.itemPerPage)
      ) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          currentPageNumbers: this.state.currentPageNumbers + 1,
        }));
      }
    }
  };
  /**
   * @method onLastPage
   * @description: navigation de la pagination ( Aller à la dernière page)
   * @param { any }    event
   * @infos "https://reactjs.org"
   */
  public onLastPage = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** comparaison de la viariable  */
    }

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      currentPageNumbers: Math.ceil(
        this.state.totalItemLength / this.state.itemPerPage
      ),
    }));
  };
  /**
   * @method onFirstPage
   * @description: navigation de la pagination (Aller à la prémière page)
   * @param { any }    event
   * @infos "https://reactjs.org"
   */
  public onFirstPage = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** comparaison de la viariable  */
    }

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ currentPageNumbers: 1 }));
  };
  /**
   * @method onPreviousPage
   * @description: navigation de la pagination ( Revenir à la page précedente)
   * @param { any }    event
   * @infos "https://reactjs.org"
   */
  public onPreviousPage = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** comparaison de la viariable  */
    }
    if (
      this.state.currentPageNumbers <=
      Math.ceil(this.state.totalItemLength / this.state.itemPerPage) + 1
    ) {
      if (1 <= this.state.currentPageNumbers - 1) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          currentPageNumbers: this.state.currentPageNumbers - 1,
        }));
      }
    }
  };
  /**
   * @method onSelectedPage
   * @description: Aller à la page sélectionnée
   * @param { number }    elem
   * @infos "https://reactjs.org"
   */
  public onSelectedPage = (elem: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ currentPageNumbers: Number(elem) }));
  };
  /**
   * @method updateUIX
   * @description: MAJ du UIX
   * @param { number }    elem
   * @infos "https://reactjs.org"
   */
  public updateUIX = (totalItemLength: number): void => {
    if (
      !Lodash.isUndefined(totalItemLength) &&
      !Lodash.isUndefined(this.state.itemPerPage)
    ) {
      {
        /** Calcul du tableau de pagination ( nombre) */
      }
      /**
       * @constant
       * @name pageNumbers
       * @type number[]
       */
      const pageNumbers: number[] = [];
      /**
       * @constant
       * @name activePage
       * @type boolean[]
       */
      const activePage: boolean[] = [];
      /**
       * @constant
       * @name activePage
       * @type boolean[]
       */
      const visible: boolean[] = [];

      {
        /** Empêcher la mutation du state */
      }
      // this.setState((state:any) : any=>({loading:true}));

      if (totalItemLength >= this.state.itemPerPage) {
        {
          /** boucle for sur le nombre total des élement par rapport en nombre disponible dans une page */
        }
        for (
          let i = 1;
          i <= Math.ceil(totalItemLength / this.state.itemPerPage + 1);
          i++
        ) {
          pageNumbers.push(i); // la numérotation des pages;
          activePage.push(false); // indication de la page qui est active ou pas;

          // des Exceptions le tableau visible: boolean[]
          if (
            this.state.firstCurrentPageLimit <
            this.state.currentPageNumbers + 1
          ) {
            if (
              this.state.currentPageNumbers - this.state.stableValue <= i &&
              i <= this.state.currentPageNumbers + this.state.stableValue
            ) {
              visible.push(true);
            } else {
              visible.push(false);
            }
          } else if (
            this.state.currentPageNumbers <= this.state.firstCurrentPageLimit
          ) {
            if (i <= this.state.firstCurrentPageLimit) {
              visible.push(true);
            } else {
              visible.push(false);
            }
          }
        }

        {
          /** bouton de pagination est active au numéro: this.state.currentPageNumbers */
        }
        activePage[Number(this.state.currentPageNumbers)] = true; // la page active

        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          activePage,
          pageNumbers,
          visible,
        }));
      } else {
        pageNumbers[1] = 1; // la numérotation des pages;
        activePage[0] = true;
        visible[0] = true;
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          activePage,
          pageNumbers,
          visible,
        }));
      }
    }
  };
  /**
   * @method handleScroll
   * @param { any }    target
   * @infos "https://reactjs.org"
   */
  public handleScroll = (event: any) => {
    /**
     * @affectation
     * @description :
     * Affectation par décomposition des élements de l'objet (props)
     * les élements existent ou sont créés dans ( ou par) la @class container
     * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
     * susceptibles de subir une affectation par décomposition
     * exemple : const { elements } = objet ;
     * @infos "https://developer.mozilla.org"
     */

    const { scrollTop } = event;

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ scrollTop }));
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** Comparaison des props */
    }
    if (prevState.scrollTop !== this.state.scrollTop) {
      {
        /** Empêcher la mutation du state */
      }
      // this.setState((state: any) => ({ scrollTop : this.state.scrollTop}));

      if (this.props.incident) {
        {
          /** mise à jour de la valeur de la page  */
        }
        this.props.onUpdateScrollTop(this.state.scrollTop); // Utilisation et mise à jour du parent
      }
    } else if (prevState.currentPageNumbers !== this.state.currentPageNumbers) {
      {
        /** Empêcher la mutation du state */
      }

      this.setState((state: any): any => ({
        currentPageNumbers: this.state.currentPageNumbers,
      }));

      {
        /**  */
      }
      this.updateUIX(this.state.totalItemLength);

      {
        /** mise à jour de la valeur de la page  */
      }
      this.props.onUpdateCurrentPageNumbers(this.state.currentPageNumbers); // Utilisation et mise à jour du parent
    } else if (prevState.totalItemLength !== this.state.totalItemLength) {
      {
        /** Empêcher la mutation du state */
      }

      this.setState((state: any): any => ({
        totalItemLength: this.state.totalItemLength,
      }));

      {
        /**  */
      }
      this.updateUIX(this.state.totalItemLength);

      {
        /** mise à jour de la valeur de la page  */
      }
      // this.props.onUpdateCurrentPageNumbers(this.state.currentPageNumbers); // Utilisation et mise à jour du parent
    } else if (prevState.totalRowElements !== this.state.totalRowElements) {
      {
        /** Empêcher la mutation du state */
      }

      this.setState((state: any): any => ({
        totalRowElements: this.state.totalRowElements,
      }));
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    this.updateUIX(this.state.totalItemLength);
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.itemPerPage !== this.props.itemPerPage) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        itemPerPage: nextProps.itemPerPage,
      }));
    } else if (nextProps.totalItemLength !== this.props.totalItemLength) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        totalItemLength: nextProps.totalItemLength,
      }));
    } else if (nextProps.currentPageNumbers !== this.props.currentPageNumbers) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        currentPageNumbers: nextProps.currentPageNumbers,
      }));
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        {...this.state}
        {...this.props}
        onNextPage={this.onNextPage}
        onSelectedPage={this.onSelectedPage}
        onPreviousPage={this.onPreviousPage}
        handleScroll={this.handleScroll}
        onFirstPage={this.onFirstPage}
        onLastPage={this.onLastPage}
      />
    );
  }
}

{
  /** exporter le HOC : connect */
}
export default connect(null, {})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/virtualized/pagination/container.tsx